export { default } from './fitment-content';
